export class FileItem {
  name: string;
  isFolder: boolean;
  size?: number;
  id: string;
  mimeType: string;
  src: string;
  dateModified: number;
  thumbnailLink: string;
}

export class GoogleFile {
  name: string;
  desc: string;
  section: string;
  id: string;
  file: string;
  path: string;
  type: string;
}

export class AuthorizationObject {
  appUrl: string;
  objCode: string;
  val1: string;
  val2: string;
  val3: string;
  val4: string;
  val5: string;
}

export class Application {
  appUrl: string;
  appDesc: string;
  appIcon: string;
  hasSidebar: boolean;
  appServer?: string;
}

export class Menu {
  appUrl: string = '';
  menuUrl: string = '';
  menuDesc: string = '';
  isPublic: boolean = false;
  menuIcon: string = '';
  parentUrl: string = '';
  orderNo: number = 0;
  action: string = '';
}

export class UserGroup {
  groupCode: string = '';
  groupDesc: string = '';
  userName: string = '';
}

export class UserObject {
  appUrl: string;
  objCode: string;
  val1: string;
  val2: string;
  val3: string;
  val4: string;
  val5: string;
}

export class User {
  userName: string;
  fullName: string;
  isActive: boolean;
  email: string;
  lastLoginTimestamp: Date;
  groups: UserGroup[];
  apps: Application[];
  menus: any;
  authObjects: any;
  userObjects: any;
  password: any;
  newPassword: any;
}
